<div class="card">
  <app-header
    titulo="Processos de Integração"
    descricao="Defina a sequência que busca, transforma e envia os dados">
  </app-header>

  <div class="surface-50 border-1 surface-border border-round p-3 mb-4 line-height-3">
    <strong>Para criar um processo:</strong> cadastre um <a routerLink="/smartinteg/sistemas">sistema</a> para organizá-lo e um
    <a routerLink="/smartinteg/provedores">provedor</a> para acessar os dados. Depois de salvar o processo, configure os recursos na ordem em que devem ser executados.
  </div>

  <p-table
    #dt
    [value]="processos"
    dataKey="id"
    [loading]="loading"
    [globalFilterFields]="['nome', 'descricao', 'sistemaNome']"
    styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
    [paginator]="true"
    [rows]="20"
    [rowsPerPageOptions]="[10, 20, 50, 100]"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros">

    <ng-template pTemplate="caption">
      <div class="flex flex-wrap align-items-center justify-content-between gap-2">
        <div class="flex align-items-center">
          <button pButton pRipple label="Novo Processo" icon="pi pi-plus" class="p-button-success mr-2" (click)="novoProcesso()"></button>
          <button pButton pRipple icon="pi pi-filter-slash" class="p-button-outlined" (click)="limparFiltros()" pTooltip="Limpar filtros" tooltipPosition="top"></button>
        </div>
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input pInputText type="text" [(ngModel)]="termoBusca" (input)="table.filterGlobal(termoBusca, 'contains')" placeholder="Buscar processo" aria-label="Buscar processo" class="w-full" />
        </span>
        <button pButton pRipple icon="pi pi-refresh" class="p-button-outlined" (click)="carregarProcessos()" [loading]="loading" pTooltip="Atualizar" tooltipPosition="top"></button>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th style="width: 5rem">Status</th>
        <th pSortableColumn="nome">Nome <p-sortIcon field="nome"></p-sortIcon></th>
        <th pSortableColumn="descricao">Descrição <p-sortIcon field="descricao"></p-sortIcon></th>
        <th pSortableColumn="sistemaNome">Sistema <p-sortIcon field="sistemaNome"></p-sortIcon></th>
        <th pSortableColumn="dtCriado">Data Criação <p-sortIcon field="dtCriado"></p-sortIcon></th>
        <th class="acoes-processo-coluna">Ações</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-processo>
      <tr>
        <td class="text-center">
          <p-button
            [icon]="getAtivoIcon(processo.ativo)"
            [pTooltip]="getAtivoLabel(processo.ativo) + '. Clique para alterar'"
            [ariaLabel]="getAtivoLabel(processo.ativo) + ' — alterar status de ' + processo.nome"
            tooltipPosition="top"
            [styleClass]="getAtivoStyleClass(processo.ativo)"
            (click)="toggleAtivo(processo)">
          </p-button>
        </td>
        <td><strong>{{ processo.nome }}</strong></td>
        <td>{{ processo.descricao }}</td>
        <td>{{ processo.sistemaNome }}</td>
        <td>{{ formatarData(processo.dtCriado) }}</td>
        <td class="acoes-processo-coluna">
          <div class="acoes-processo" role="group" [attr.aria-label]="'Ações de ' + processo.nome">
            <button pButton pRipple icon="pi pi-sitemap" label="Configurar fluxo" class="p-button-info p-button-outlined p-button-sm acao-fluxo" (click)="visualizarRecursos(processo)" [attr.aria-label]="'Configurar fluxo de ' + processo.nome"></button>
            <div class="acoes-processo-secundarias">
              <button pButton pRipple icon="pi pi-play" class="p-button-rounded p-button-success p-button-text p-button-sm" (click)="executarProcesso(processo)" [attr.aria-label]="'Executar ' + processo.nome" pTooltip="Executar agora" tooltipPosition="top"></button>
              <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-button-text p-button-sm" (click)="editarProcesso(processo)" [attr.aria-label]="'Editar ' + processo.nome" pTooltip="Editar dados" tooltipPosition="top"></button>
              <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text p-button-sm" (click)="deletarProcesso(processo)" [attr.aria-label]="'Excluir ' + processo.nome" pTooltip="Excluir" tooltipPosition="top"></button>
            </div>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6" class="text-center p-4">Nenhum processo cadastrado. Use <strong>Novo Processo</strong> para começar.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
